import { HttpInterceptorFn } from '@angular/common/http'

/**
 * Interceptor that ensures all API URLs end with a trailing slash.
 * Required by Django REST Framework which expects trailing slashes by default.
 * Skips static resources (files with extensions like .png, .jpg, .svg, etc.)
 */
export const trailingSlashInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url
  const urlWithoutQuery = url.split('?')[0]

  // Skip if URL already ends with slash
  if (urlWithoutQuery.endsWith('/')) {
    return next(req)
  }

  // Skip static resources (URLs with file extensions)
  const lastSegment = urlWithoutQuery.split('/').pop() || ''
  if (lastSegment.includes('.')) {
    return next(req)
  }

  // Add trailing slash to API URLs
  const queryString = url.includes('?') ? url.substring(url.indexOf('?')) : ''
  const newUrl = urlWithoutQuery + '/' + queryString

  return next(req.clone({ url: newUrl }))
}
